import { DomainSerializer } from 'src/app/global/serializables/domain.serializer';
import { Equipe } from '../domain/equipe.model';

export class EquipeSerializer extends DomainSerializer<Equipe> {}
